import { Button, Divider } from 'antd'
import { useHistory, Link } from 'react-router-dom'
import { useSelector, shallowEqual } from 'dva'
import { removeSession } from '@sisyphe/utils'
import './index.less'

type Props = {}

const selector = ({ login }) => ({
  userInfo: login.userInfo,
})
const Navbar = (props: Props) => {
  const { userInfo } = useSelector(selector, shallowEqual)
  const history = useHistory()

  const logOut = () => {
    removeSession()
    history.replace('/login')
  }

  // 打开新页面
  const openNewPage = path => {
    window.open(path)
  }

  return (
    <nav className="navbar">
      <div className="left">欢迎来到西西弗企业采购平台</div>
      <div className="right">
        <div>
          <Link to="/mine/id" className="username">
            你好，来自{userInfo?.shortName}的{userInfo?.userName}
          </Link>
          <Button type="ghost" onClick={logOut}>
            [退出]
          </Button>
        </div>
        <div className="menus">
          <Link to="/">商城首页</Link>
          <Divider type="vertical" />
          <div
            className="menus-link"
            onClick={() => openNewPage('/mine/order')}
          >
            我的订单
          </div>
          <Divider type="vertical" />
          <div className="menus-link" onClick={() => openNewPage('/cart')}>
            购物车
          </div>
          <Divider type="vertical" />
          <div className="menus-link" onClick={() => openNewPage('/mine/id')}>
            账号信息
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
